import { AutogenModelDeductCodeEdi, AutogenRowDeductCodeEdi } from "./autogen/AutogenModelDeductCodeEdi";

export class ModelDeductCodeEdi extends AutogenModelDeductCodeEdi<RowDeductCodeEdi> {
	constructor() {
		super(RowDeductCodeEdi);
	}
}

export class RowDeductCodeEdi extends AutogenRowDeductCodeEdi {
}